import React from "react";
import Block from "../../Block";

class UAGBAdvancedHeading extends Block {
  render() {
    const { block } = this.props;

    const extractedText = block.originalContent.replace( /(<([^>]+)>)/ig, '')

    return <h2>{extractedText}</h2>;
  }
}

class UAGBAdvancedHeadingFactory {
  get type() {
    return "uagb/advanced-heading";
  }

  create(props) {
    return <UAGBAdvancedHeading {...props} />;
  }
}

export default UAGBAdvancedHeadingFactory;
